import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class AgroVisitaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, propriedadeLenght, planosafraLength, pdadetalhe, refs) {
        let validated = true;

        let disabledByNoPropriedade = (propriedadeLenght<1 && model.idcliente!=null );

        if (Util.isNull(model.idempresa)) {
            refs.empresaSelect.focusedOut = true;
            validated = false;
        }
        if (Util.isNull(model.idcliente)) {
            refs.clienteSelect.focusedOut = true;
            validated = false;
        }
        if(
            (pdadetalhe.propriedade
            &&!pdadetalhe.propriedade.oculta
            &&pdadetalhe.propriedade.obrigainclusao)
            || !pdadetalhe.propriedade
        ) {
            if (Util.isNull(model.uuidagro_propriedade)&&!disabledByNoPropriedade) {
                refs.propriedadeSelect.focusedOut = true;
                validated = false;
            }
        }
        if(
            (pdadetalhe.area
            &&!pdadetalhe.area.oculta
            &&pdadetalhe.area.obrigainclusao)
            || !pdadetalhe.area
        ) {
            if (Util.isNull(model.uuidagro_area)&&!disabledByNoPropriedade) {
                refs.areaSelect.focusedOut = true;
                validated = false;
            }
        }
        if(
            (pdadetalhe.talhao
            &&!pdadetalhe.talhao.oculta
            &&pdadetalhe.talhao.obrigainclusao)
            || !pdadetalhe.talhao
        ) {
            if (Util.isNull(model.uuidagro_talhao)&&!disabledByNoPropriedade) {
                refs.talhaoSelect.focusedOut = true;
                validated = false;
            }
        }

        // se tiver pdadetalhe
        if(
            (pdadetalhe.planosafra
            && !pdadetalhe.planosafra.oculta
            && pdadetalhe.planosafra.obrigainclusao)
            && Util.isNull(model.uuidagro_planosafra)
        ) {
            refs.planosafraSelect.focusedOut = true;
            validated = false;
        }
        // se não tiver pdadetalhe mas tiver planosafra para 
        if (
            !pdadetalhe.planosafra
            && planosafraLength>0 
            && !disabledByNoPropriedade
            && Util.isNull(model.uuidagro_planosafra)
        ) {
            refs.planosafraSelect.focusedOut = true;
            validated = false;
        }
        // se tiver pdadetalhe, não for obrigatório mas tiver planosafra para selecionar
        if(
            (pdadetalhe.planosafra
            && !pdadetalhe.planosafra.oculta
            && !pdadetalhe.planosafra.obrigainclusao)
            && !disabledByNoPropriedade
            && planosafraLength>0 
            && Util.isNull(model.uuidagro_planosafra)
        ) {
            refs.planosafraSelect.focusedOut = true;
            validated = false;
        }

        if(
            (pdadetalhe.safra
            &&!pdadetalhe.safra.oculta
            &&pdadetalhe.safra.obrigainclusao)
            || !pdadetalhe.safra
        ) {
            if (Util.isNull(model.idagro_safra)&&planosafraLength<1) {
                refs.safraSelect.focusedOut = true;
                validated = false;
            }
        }
        if(
            (pdadetalhe.cultura
            &&!pdadetalhe.cultura.oculta
            &&pdadetalhe.cultura.obrigainclusao)
            || !pdadetalhe.cultura
        ) {
            if (Util.isNull(model.idagro_cultura)&&planosafraLength<1) {
                refs.culturaSelect.focusedOut = true;
                validated = false;
            }
        }
        if(
            pdadetalhe.motivovisita
            &&!pdadetalhe.motivovisita.oculta
            &&pdadetalhe.motivovisita.obrigainclusao
        ) {
            if (Util.isNull(model.idagro_motivovisita)) {
                refs.motivoSelect.focusedOut = true;
                validated = false;
            }
        }
        if(
            pdadetalhe.assuntovisita
            &&!pdadetalhe.assuntovisita.oculta
            &&pdadetalhe.assuntovisita.obrigainclusao
        ) {
            if (Util.isNull(model.idagro_assuntovisita)) {
                refs.assuntoSelect.focusedOut = true;
                validated = false;
            }
        }
        
        return validated;
    }

}